import { create } from 'zustand';

type PhraseHandler = (phrase: string) => void;

interface PredefinedPhrasesState {
  setPhraseHandler: (handler: PhraseHandler | null) => void;
  requestPhraseInsertion: (phrase: string) => void;
}

export const usePredefinedPhrasesStore = create<PredefinedPhrasesState>(() => {
  let phraseHandler: PhraseHandler | null = null;

  return {
    setPhraseHandler: (handler): void => {
      phraseHandler = handler;
    },
    requestPhraseInsertion: (phrase): void => {
      phraseHandler?.(phrase);
    },
  };
});
